<template>
  <div id="system-publish-management-team">
    <div class="relative line-h-40 mar-b-20">
      <div class="ipub-tab-list">
        <a @click="changeStatus('')"
           :class="['ipub-tab-list--tab',params.released===''?'active':'']">All Status</a>
        <a @click="changeStatus(true)"
           :class="['ipub-tab-list--tab',params.released===true?'active':'']">Published</a>
        <a @click="changeStatus(false)"
           :class="['ipub-tab-list--tab',params.released===false?'active':'']">Draft</a>
      </div>
      <div class="right-option ipub-p1">
        <ipub-button v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.TEAM.ADD')"
                     type="primary"
                     @click="add">
          Add New Team Member
        </ipub-button>
      </div>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  :pagination="false"
                  draggable
                  @drag="setSort"
                  :dataSource="dataSource">
        <template v-slot:name="{record}">
          {{record.firstName}} {{record.lastName}}
        </template>
        <template v-slot:avatar="{text}">
          <img style="height:50px"
               :src="`${domain}/${text||'imageFile/icon.svg'}`"
               alt="">
        </template>
        <template v-slot:title="{text}">
          {{title[text]}}
        </template>
        <template v-slot:roles="{text}">
          {{managementTeam[text]}}
        </template>
        <template v-slot:time="{record}">
          {{ (record.updateTime||record.createTime)?$moment(record.updateTime||record.createTime).format('HH : mm DD / MM / YYYY'): '- -' }}
        </template>
        <template v-slot:status="{text}">
          <template v-if="text">
            <ipub-label cover
                        style="width:80px"
                        type="success"
                        size="small">Published</ipub-label>
          </template>
          <template v-else>
            <ipub-label cover
                        style="width:80px"
                        type="danger"
                        size="small">Draft</ipub-label>
          </template>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.TEAM.EDIT')"
                        class="border-right">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
          <template v-if="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.TEAM.PUBLISH')">
            <ipub-tooltip v-if="record.released"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-else
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record)" />
            </ipub-tooltip>
          </template>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISH.TEAM.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Add ref="management-team-add"
         :isVisable="isVisable"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
